module.exports = function forEach(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(i, arr[i]);
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/chickencurry/lib/forEach.js
// module id = 207
// module chunks = 0